export const AMICAL_VALIDATION_STATUS = {
  PENDING: 'pending',
  VALIDATED: 'validated',
  REJECTED: 'rejected',
  CANCELLED: 'cancelled',
}

export const AMICAL_VALIDATION_LABELS = {
  [AMICAL_VALIDATION_STATUS.PENDING]: 'En attente',
  [AMICAL_VALIDATION_STATUS.VALIDATED]: 'Validée',
  [AMICAL_VALIDATION_STATUS.REJECTED]: 'Rejetée',
  [AMICAL_VALIDATION_STATUS.CANCELLED]: 'Annulée',
}

const AMICAL_VALIDATION_STYLES = {
  [AMICAL_VALIDATION_STATUS.PENDING]: 'bg-amber-50 text-amber-700 ring-amber-100',
  [AMICAL_VALIDATION_STATUS.VALIDATED]: 'bg-green-50 text-green-700 ring-green-100',
  [AMICAL_VALIDATION_STATUS.REJECTED]: 'bg-red-50 text-red-700 ring-red-100',
  [AMICAL_VALIDATION_STATUS.CANCELLED]: 'bg-gray-100 text-gray-600 ring-gray-200',
}

export const getAmicalValidationStatus = (row) => {
  if (!row || Number(row.is_amical) !== 1) return null
  if (row.status === 'cancelled' || row.voucher_status === 'annulé') {
    return AMICAL_VALIDATION_STATUS.CANCELLED
  }
  if (Number(row.is_amical_rejected) === 1) return AMICAL_VALIDATION_STATUS.REJECTED
  if (Number(row.is_amical_validated) === 1) return AMICAL_VALIDATION_STATUS.VALIDATED
  return AMICAL_VALIDATION_STATUS.PENDING
}

export const getAmicalValidationLabel = (row) => {
  const status = getAmicalValidationStatus(row)
  return status ? AMICAL_VALIDATION_LABELS[status] : null
}

export const getAmicalValidationClassName = (status) =>
  AMICAL_VALIDATION_STYLES[status] ?? 'bg-gray-100 text-gray-500 ring-gray-200'
